import { Box, Typography } from '@mui/material';
import { LessonAppointmentAvailability } from 'common/infrastructure/modules/appointment/interfaces/AvailabilityTypes';
import React, { FC, useEffect, useState } from 'react';

import { WizardStep } from 'domain/entities/WizardStep';
import { formatPhoneNumber } from 'infrastructure/targets/web/modules/common/helpers';
import useEventTracking, {
  EventType,
} from 'infrastructure/targets/web/modules/common/hooks/useEventTracking';
import useCaseSelectInstructorWeb from 'application/modules/bookingWizard/useCases/hooks/useCaseSelectInstructorWeb';
import { useAppSelector } from 'infrastructure/redux/store/hooks';
import { selectLocation } from 'infrastructure/redux/slices/bookingWizard.selector';
import InstructorsFilterSelect from 'infrastructure/targets/web/modules/bookingWizard/Steps/SelectInstructorStep/components/InstructorsFilterSelect';
import InstructorsList from 'infrastructure/targets/web/modules/bookingWizard/Steps/SelectInstructorStep/components/InstructorsList';
import { StyledTitleContainer } from 'infrastructure/targets/web/modules/bookingWizard/Steps/SelectFittingTypesStep/style';

interface IClubFittingByCoach {
  heading: string;
  phoneNumber?: string;
  stepName: WizardStep;
}

const ClubFittingByCoach: FC<IClubFittingByCoach> = ({ heading, phoneNumber, stepName }) => {
  const selectedLocationId = useAppSelector(selectLocation);

  const {
    result: instructorsList,
    inProgress: instructorsLoading,
    nextStep,
    getInstructors,
    userEmail: email,
  } = useCaseSelectInstructorWeb(stepName);
  const [instructorsToShow, setInstructorsToShow] = useState(instructorsList);
  const { sendEvent } = useEventTracking();

  useEffect(() => {
    if (selectedLocationId) {
      getInstructors({
        locationId: selectedLocationId,
        email,
        checkAvailability: true,
      });
    }
  }, [selectedLocationId, email]);

  const handleCardClick = (value: number) => {
    nextStep(value, false);
    sendEvent(EventType.SelectExperience, {
      experience: 'lesson',
      instructor: instructorsList?.find((i) => i.staffId === value),
      utm: (() => {
        const utm = localStorage.getItem('utm');
        return utm ? JSON.parse(utm) : null;
      })(),
    });
  };
  useEffect(() => {
    if (instructorsList) {
      setInstructorsToShow(filterForClubFittingStaff(instructorsList));
    }
  }, [instructorsList]);

  const filterForClubFittingStaff = (instructors: LessonAppointmentAvailability[]) =>
    instructors?.filter((instructor) => {
      const services = instructor.services.map((service) => service.title);
      const offersClubFitting = services.some((service) =>
        service.toLocaleLowerCase().includes('fitting'),
      );
      return offersClubFitting;
    });

  const handleInstructorsFilter = (instructorTypes: string[]) => {
    const filteredInstructors = instructorsList?.filter((instructor) =>
      instructorTypes.includes(instructor.staffLevel),
    );
    if (filteredInstructors) {
      setInstructorsToShow(filterForClubFittingStaff(filteredInstructors));
    }
  };
  return (
    <>
      <StyledTitleContainer>
        <Typography variant="h3">{heading}</Typography>
        <InstructorsFilterSelect onChange={handleInstructorsFilter} />
      </StyledTitleContainer>
      {instructorsToShow?.length === 0 ? (
        <Box padding={6}>
          <Typography variant="h5" textAlign="center">
            {`Club fitting is not currently available. Please select another location or call
    ${formatPhoneNumber(phoneNumber)} to get more information.`}
          </Typography>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <InstructorsList
            loading={instructorsLoading}
            onCardClick={handleCardClick}
            instructorsList={instructorsToShow}
          />
        </Box>
      )}
    </>
  );
};

export default ClubFittingByCoach;
